<div class="cont-center">
  <div class="mc-device-details">
    <div class="device-details-header">
      <app-details-header [device]="device"></app-details-header>
      <app-tabs-switcher> </app-tabs-switcher>
    </div>

    <div class="device-details-content" sa-fill fill-min-height="true">
      <router-outlet> </router-outlet>
    </div>
  </div>
</div>
